var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 5.16065L8.87325 4.74732L6.99992 0.333984L5.12659 4.75398L0.333252 5.16065L3.97325 8.31398L2.87992 13.0007L6.99992 10.514L11.1199 13.0007L10.0333 8.31398L13.6666 5.16065ZM6.99992 9.26732V3.06732L8.13992 5.76065L11.0599 6.01399L8.84659 7.93398L9.51325 10.7873L6.99992 9.26732Z",
    fill: "#01875F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStar);
export default __webpack_public_path__ + "static/media/halfStar.00844a979d09b4caeea03cdb0b7a135e.svg";
export { ForwardRef as ReactComponent };